import { assoc } from 'ramda';
import { toSuccess } from 'react-async-client';
import { put, takeEvery, all } from 'redux-saga/effects';
import { login } from 'actions/userActions';

import { APP_RUN, GET_COMPANY_INFO } from 'constants/actionTypes';

import { addDefaultHeader } from 'utils/http';
import { getAuthToken, getAuthSSO, setAuthSSO } from 'utils/token';
import webCatalog from 'utils/webCatalog';

import { setLocale } from 'yup';
import yupLocale from 'constants/yupLocale';
setLocale(yupLocale);

function* setLoginToken() {
    yield takeEvery(APP_RUN, function* loginToken() {
        addDefaultHeader('Web-Catalog', webCatalog);

        const token = getAuthToken();
        const sso = getAuthSSO();

        if (token && !sso) {
            const action = login.success({ token });
            yield put(
                assoc('requestAction', {}, action)
            );
        }
    });
}

function* setSSOLogin() {
    yield takeEvery(toSuccess(GET_COMPANY_INFO), function(action) {
        setAuthSSO(!!action.payload.sso);
    });
}

export default function* watchAppRun() {
    yield all([
        setLoginToken(),
        setSSOLogin(),
    ]);
}
